
import { Component, OnInit, NgZone, HostListener, OnDestroy, ViewChild } from '@angular/core';
import { debounceTime } from 'rxjs/operators';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Subscription, BehaviorSubject } from 'rxjs';
import { Router, ActivatedRoute, Params, RouterLink } from '@angular/router';
import { MobileNavService } from '../../shared/services/mobile-nav.service';
import { AuthService } from '../../shared/services/auth/auth.service';
import { AssociateService } from '../shared/services/associate.service';
import { TranslateService } from '@ngx-translate/core';
import { StaticValueService } from '../../shared/services/static-value.service';
import { Sort, PageEvent, MatPaginator } from '@angular/material';
import { OrganizationService } from '../../shared/services/organization.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { MobileFilterComponent } from '../../shared/components/mobile-filter/mobile-filter.component';
import { Configuration } from '../../app.constants';
import { IonicAngular4CacheService } from 'ionic-angular4-cache';
import { ProfileCardPopupComponent } from '../../shared/components/profile-card-popup/profile-card-popup.component';

@Component({
    selector: 'app-search',
    templateUrl: './search.component.html',
    styleUrls: ['./search.component.css']
})
export class SearchComponent implements OnInit, OnDestroy {

    public serverApiUrl;
    public isLoading: Boolean = false;
    public isAdmin: Boolean = false;
    public sub: any;
    public id: number;
    public validation: Boolean = true; // by default displays search, will display validation button if true
    public countries: any;
    public organizations: any;
    public selectedOrganization = null;
    public selectedCountry = null;
    public selectedTeam = null;
    public employeeSearch = null;
    public teams: string[] = ['Finance', 'RnD', 'HR'];
    public canValidate: Boolean = false;
    public users: any = [];
    public search: any = JSON;
    public query: any;
    public staticDDList: any;
    public currentUserId: string;
    public pageIndex = 1;
    public organizationSubsidiaries = [];
    public searchNameBeh = new BehaviorSubject<string>('');
    public searchNameObs = this.searchNameBeh.asObservable();
    public obserablesArr = [];
    public activeStatus = 'Active';
    public isHrManager: Boolean = false;;

    length = 3;
    pageSize = 10;
    pageSizeOptions = [5, 10, 25, 100];

    // MatPaginator Output
    pageEvent: PageEvent;

    @ViewChild(MatPaginator) paginator: MatPaginator



    constructor(public route: ActivatedRoute,
        public _router: Router,
        public mobileNav: MobileNavService,
        public authService: AuthService,
        public associateService: AssociateService,
        public translate: TranslateService,
        public dialog: MatDialog,
        // public ngZone:NgZone,
        public staticService: StaticValueService,
        public organizationService: OrganizationService,
        public config: Configuration,
        public ionicAngular4Cache: IonicAngular4CacheService) {
        this.translate.use(this.staticService.getLanguage());
        this.translate.onLangChange.subscribe(res => {
            this.translate.use(res.lang);
        });
        this.staticDDList = this.staticService.staticData.staticDD;
    }

    nameSearched() {
        this.searchNameBeh.next(this.search.name);
    }

    ngOnDestroy() {
        this.obserablesArr.forEach(element => {
            element.unsubscribe();
        });
    }

    ngOnInit() {
        this.obserablesArr.push(this.searchNameObs.pipe(debounceTime(700)).subscribe(value => {
            this.onChange();
        }));

        this.serverApiUrl = this.config.StaticImageUrl;
        this.currentUserId = this.authService.user.associateId;
        if (this.authService.user.role === 'HR Manager') {
            this.isHrManager = true;
            this.canValidate = true;
        } else {
            this.canValidate = false;
        }
        if (this.authService.user.role === 'Admin') {
            this.isAdmin = true;
        } else {
            this.isAdmin = false;
        }

        this.associateService.getDistinctAssociateCountries().subscribe(data => {
            this.countries = data;
        }, error => { });
        this.organizationService.getOrganization().subscribe((data) => {
            this.organizations = data;
        }, (error) => { });
        this.associateService.getAssociateCount().subscribe((data: number) => {
            this.length = data;
        }, (err) => { });

        this.query = {
            search: {
                'active': true,
                'contractDetails.activeStatus': { $ne: 'Inactive' },
                // 'team': ''
            },
            sort: { 'personalInformation.familyName': 1 },
            pagination: {
                pageIndex: 0,
                pageSize: this.pageSize
            }
        };
        this.search = {
            name: '',
            country: '',
            organization: '',
            gender: '',
            team: '',
            jobCategory: '',
            subsidiary: '',
            activeStatus: 'Active',
            archived: 'false'
        };

        // this.getAssociatesFromService();
    }
    getServerData(event) {
        this.query.pagination.pageIndex = event.pageIndex;
        this.query.pagination.pageSize = event.pageSize;
        this.pageIndex = event.pageIndex;
        this.getAssociatesFromService();
    }

    setPageSizeOptions(setPageSizeOptionsInput: string) {
        this.pageSizeOptions = setPageSizeOptionsInput.split(',').map(str => +str);
    }

    sortData(sort: Sort) {
        this.query.sort = {};
        if (sort.direction === 'asc') {
            this.query.sort[sort.active] = -1;
        } else if (sort.direction === 'desc') {
            this.query.sort[sort.active] = 1;
        }
        this.getAssociatesFromService();
    }

    onClickMe() {
        this.mobileNav.showSideNav();
    }

    companyChange() {
        this.organizationSubsidiaries = [];
        if (this.search.organization !== '') {
            let temp = [];
            temp.push(this.search.organization);
            const subsidiaryIds = this.organizationService.getSubsidiariesOrganization(temp, this.organizations);
            for (let i = 0; i < subsidiaryIds.length; i++) {
                for (let j = 0; j < this.organizations.length; j++) {
                    if (subsidiaryIds[i] === this.organizations[j]._id) {
                        let tempSubs = this.organizations[j];
                        this.organizationSubsidiaries.push(tempSubs);
                    }
                }
            }
        }
    }

    onChange() {
        this.companyChange();
        this.pageIndex = 1;
        let companyQuery;
        if (this.search.organization === '' || this.search.subsidiary === '') {
            companyQuery = this.search.organization;
        } else {
            companyQuery = { $in: [this.search.organization, this.search.subsidiary] };
        }
        if (this.search.archived === 'true') {
            const tempSearch = {
                'active': false,
                'personalInformation.fullName': { $regex: '', $options: 'i' },
                'personalInformation.gender': '',
                'jobDescription.company.id': '',
                'workContactDetails.workCountry': '',
                'jobDescription.jobCategory': '',
                // 'team': ''
            };
            this.query.search = Object.assign({}, tempSearch);
        } else if (this.search.archived === 'false') {
            const tempSearch = {
                'active': true,
                'contractDetails.activeStatus': { $ne: 'Inactive' },
                'personalInformation.fullName': { $regex: '', $options: 'i' },
                'personalInformation.gender': '',
                'jobDescription.company.id': '',
                'workContactDetails.workCountry': '',
                'jobDescription.jobCategory': ''
                // 'team': ''
            };
            this.query.search = Object.assign({}, tempSearch);
        } else if (this.search.archived === 'Inactive') {
            const tempSearch = {
                'active': true,
                'contractDetails.activeStatus': 'Inactive',
                'personalInformation.fullName': { $regex: '', $options: 'i' },
                'personalInformation.gender': '',
                'jobDescription.company.id': '',
                'workContactDetails.workCountry': '',
                'jobDescription.jobCategory': ''
                // 'team': ''
            };
            this.query.search = Object.assign({}, tempSearch);
        }
        this.query.search['personalInformation.fullName'] = { $regex: this.search.name, $options: 'i' };
        this.query.search['personalInformation.gender'] = this.search.gender;
        this.query.search['jobDescription.company.id'] = companyQuery;
        this.query.search['workContactDetails.workCountry'] = this.search.country;
        // tslint:disable-next-line:max-line-length
        this.query.search['jobDescription.jobCategory'] = this.search.jobCategory;
        console.log(this.search.archived);
        this.query.pagination.pageIndex = 0;
        this.query.pagination.pageSize = this.pageSize;

        // reset pagination pageindex to 0
        this.paginator.pageIndex = 0;

        this.getAssociatesFromService();
    }

    getAssociates() {
        this.ionicAngular4Cache.getItemOld('associateSearch').then((data) => {
            if (data) {
                this.users = data['data'].filter(associate => {
                    return associate;
                });
                this.length = data['numberOfSelectedAssociates'];
            }
        }).catch((error) => { });
    }
    getAssociatesFromService() {
        this.isLoading = true;
        this.associateService.search(
            this.query.pagination.pageIndex,
            this.query.pagination.pageSize,
            this.query.search,
            this.query.sort)
            .then((data1) => {
                this.isLoading = false;
                this.users = data1['data'].filter(associate => {
                    return associate;
                });
                // this.users = [new Set(this.users.map(user => user._id))];
                this.length = data1['numberOfSelectedAssociates'];
            }, (err) => {
                this.isLoading = false;
                this.getAssociates();
            });
    }

    getAssociatesMobile(pageIndex) {
        this.getAssociatesMobileFromService(pageIndex);
    }
    getAssociatesMobileFromService(pI) {
        this.isLoading = true;
        this.associateService.search(
            pI,
            10,
            this.query.search,
            this.query.sort)
            .then((data) => {
                this.isLoading = false;
                this.users = this.users.concat(data['data'].filter(associate => {
                    return associate;
                }));
                // this.users = [new Set(this.users.map(user => user._id))];
                this.length = data['numberOfSelectedAssociates'];
                this.pageIndex = this.pageIndex + 1;
            }, (err) => {
                this.isLoading = false;
                this.getAssociates();
            });
    }

    onClickFilter() {
        let dialogRef = this.dialog.open(MobileFilterComponent, {
            width: '300px',
            data: {
                type: 'associate',
                country: this.search.country,
                organization: this.search.organization,
                jobCategory: this.search.jobCategory,
                gender: this.search.gender
            }
        });
        dialogRef.afterClosed().subscribe(res => {
            if (res !== undefined) {
                this.search.country = res.country;
                this.search.organization = res.organization;
                this.search.jobCategory = res.jobCategory;
                if (res.gender === 'Male') {
                    this.search.gender = { $in: ['Male', 'Male Transgender'] };
                } else if (res.gender === 'Female') {
                    this.search.gender = { $in: ['Female', 'Female Transgender'] };
                } else {
                    this.search.gender = { $in: ['Female', 'Female Transgender', 'Male', 'Male Transgender'] };
                }
                this.onChange();
            }
        });
    }
    mobileRouting(url, id) {
        if (window.innerWidth < 600) {
            this._router.navigate([url, id]);
        }
    }

    @HostListener('window:scroll', ['$event']) onScrollEvent($event) {
        if (window.innerWidth < 768) {
            let h = document.documentElement,
                b = document.body,
                st = 'scrollTop',
                sh = 'scrollHeight';
            var percent = (h[st] || b[st]) / ((h[sh] || b[sh]) - h.clientHeight) * 100;
            if (percent === 100) {
                this.getAssociatesMobile(this.pageIndex);
            }
        }
    }

    openCard(associateObject) {
        let dialogRef = this.dialog.open(ProfileCardPopupComponent, {
            width: '750px',
            height: '378px',
            panelClass: 'profile-card-dialog',
            data: {
                'associate': associateObject
            }
        });
        dialogRef.afterClosed().subscribe(response => {
            if (response === 'Cancel') {

            } else if (response === 'Proceed') {
                this._router.navigate(['/home/associate/profile/view', associateObject._id]);
            }
        });
    }
}


function compare(a, b, isAsc) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}
